import React, { useState } from 'react';
import { Building2, RefreshCw, Bot, Sparkles, Send, CheckCircle2 } from 'lucide-react';

const roadmap = [
  {
    icon: Building2,
    title: 'Trading Multi-Broker',
    desc: 'Hubungkan akun trading Anda dari berbagai sekuritas dalam satu aplikasi terintegrasi.',
    tag: 'Q2 2027',
    tagColor: '#0C8F86',
  },
  {
    icon: RefreshCw,
    title: 'Portfolio Sync Otomatis',
    desc: 'Sinkronisasi portofolio secara real-time dengan rekening efek dan dompet crypto Anda.',
    tag: 'Q3 2027',
    tagColor: '#8b5cf6',
  },
  {
    icon: Bot,
    title: 'AI Trading Bot',
    desc: 'Bot trading otomatis berbasis AI yang dapat mengeksekusi strategi Anda 24/7.',
    tag: 'Q4 2027',
    tagColor: '#f59e0b',
  },
];

function ComingSoon() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <section className="coming-soon" style={{ padding: '100px 0', background: 'var(--surface)', overflow: 'hidden' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block-text center" style={{ marginBottom: 48 }}>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 8,
                background: 'rgba(12,143,134,0.1)', borderRadius: 100,
                padding: '6px 18px', marginBottom: 16,
                border: '1px solid rgba(12,143,134,0.12)',
              }}>
                <Sparkles size={14} color="#0C8F86" />
                <span style={{ color: '#0C8F86', fontSize: 13, fontWeight: 600 }}>Coming Soon — v2.0</span>
              </div>
              <h3 className="heading">Fitur yang Sedang Dikembangkan</h3>
              <p className="fs-20" style={{ color: 'var(--text)', maxWidth: 550, margin: '12px auto 0' }}>
                Kami terus berinovasi untuk memberikan pengalaman trading terbaik. Ini yang akan hadir selanjutnya.
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center" style={{ marginBottom: 64 }}>
          {roadmap.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="col-xl-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay={index * 150}
                style={{ marginBottom: 20 }}
              >
                <div style={{
                  background: 'var(--bg)',
                  borderRadius: 20,
                  padding: '34px 26px',
                  border: '1px solid var(--line)',
                  height: '100%',
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                }}>
                  {/* Tag ribbon */}
                  <div style={{
                    position: 'absolute', top: 0, right: 0,
                    background: item.tagColor,
                    color: '#fff', fontSize: 10, fontWeight: 700,
                    padding: '6px 18px', borderRadius: '0 20px 0 14px',
                    letterSpacing: '0.5px',
                  }}>
                    {item.tag}
                  </div>
                  <div style={{
                    width: 56, height: 56, borderRadius: 14,
                    background: `${item.tagColor}15`,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    marginBottom: 18,
                  }}>
                    <Icon size={26} color={item.tagColor} />
                  </div>
                  <h5 style={{ fontSize: 18, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 10 }}>
                    {item.title}
                  </h5>
                  <p style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.7 }}>
                    {item.desc}
                  </p>

                  {/* Progress indicator */}
                  <div style={{ marginTop: 20 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                      <span style={{ color: 'var(--text)', fontSize: 11 }}>Progress</span>
                      <span style={{ color: item.tagColor, fontSize: 11, fontWeight: 600 }}>
                        {index === 0 ? '30%' : index === 1 ? '10%' : '0%'}
                      </span>
                    </div>
                    <div style={{ height: 4, background: 'var(--line)', borderRadius: 2, overflow: 'hidden' }}>
                      <div style={{
                        width: index === 0 ? '30%' : index === 1 ? '10%' : '0%',
                        height: '100%', background: item.tagColor,
                        borderRadius: 2, transition: 'width 1s ease',
                      }} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Newsletter subscribe */}
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8 col-md-10">
            <div style={{
              background: 'var(--bg)',
              borderRadius: 20,
              padding: '44px 36px',
              border: '1px solid var(--line)',
              textAlign: 'center',
              boxShadow: '0 4px 24px rgba(0,0,0,0.04)',
            }}>
              <div style={{
                width: 52, height: 52, borderRadius: '50%',
                background: 'rgba(12,143,134,0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px',
              }}>
                <Send size={24} color="#0C8F86" />
              </div>
              <h5 style={{ fontSize: 20, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 8 }}>
                Dapatkan Update Terbaru
              </h5>
              <p style={{ color: 'var(--text)', fontSize: 14, marginBottom: 24 }}>
                Berlangganan newsletter untuk info fitur baru, tips trading, dan promo eksklusif dari Tradiora.
              </p>
              {subscribed ? (
                <div style={{
                  background: 'rgba(88,189,125,0.1)', borderRadius: 12,
                  padding: '16px 24px', color: '#58bd7d', fontWeight: 600, fontSize: 15,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                }}>
                  <CheckCircle2 size={18} />
                  Terima kasih! Anda akan mendapat update dari kami.
                </div>
              ) : (
                <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 8, maxWidth: 460, margin: '0 auto' }}>
                  <input
                    type="email"
                    placeholder="Masukkan alamat email Anda"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{
                      flex: 1,
                      padding: '14px 18px',
                      borderRadius: 12,
                      border: '1px solid var(--line)',
                      background: 'var(--surface)',
                      color: 'var(--onsurface)',
                      fontSize: 14,
                      outline: 'none',
                    }}
                  />
                  <button
                    type="submit"
                    style={{
                      padding: '14px 28px',
                      borderRadius: 12,
                      border: 'none',
                      background: 'linear-gradient(135deg, #0C8F86, #087a72)',
                      color: '#fff',
                      fontWeight: 700,
                      fontSize: 14,
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      display: 'flex', alignItems: 'center', gap: 6,
                      boxShadow: '0 6px 20px rgba(12,143,134,0.25)',
                    }}
                  >
                    <Send size={16} />
                    Langganan
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ComingSoon;
